import React, { useState } from "react";
import {
  Grid,
  Box,
  Typography,
  Avatar,
  TextField,
  Switch,
  Button,
  Paper,
  Divider,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { CustomSecondaryEditButton } from "../../Global_Component/GlobalButtonComponent";
import { EditableTextField } from "../../Global_Component/CustomInputComponent";
const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: "12px",
}));

const SettingsPage = () => {
  const [isEdit, setIsEdit] = useState(false);
  return (
    <Box sx={{ padding: 1.5, width: "100%", bgcolor: "#EDF2FA", height: "100%" }}>
      <StyledPaper elevation={2} sx={{ p: 2,  }}>
        <Grid container spacing={0} sx={{}}>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h5" fontWeight="500">
              Settings
            </Typography>

            <CustomSecondaryEditButton
              label={"Edit"}
              onClick={(e) => setIsEdit(!isEdit)}
            />
          </Grid>

          <Grid item xs={12}>
            <Box sx={{ my: 2 }}>
              <Divider
                sx={{
                  height: "2px",
                  backgroundColor: "gray",
                }}
                flexItem
              />
            </Box>
            <Grid container>
              <Grid
                item
                xs={12}
                md={4}
                sx={{
                  display: "flex",
                  alignItems: "start",
                  justifyContent: "flex-start",
                  flexDirection: "column",
                  px: 1,
                }}
              >
                <Typography
                  variant="h6"
                  mt={2}
                  sx={{ fontWeight: "500", my: 1 }}
                >
                  User Profile
                </Typography>
                <Box textAlign="left">
                  <Avatar
                    src="https://tse3.mm.bing.net/th?id=OIP.Tmv41nnfKuzzmskJzaqHvgHaFU&pid=Api&P=0&h=180"
                    alt="User Avatar"
                    sx={{ width: 130, height: 130, margin: "auto" }}
                  />
                </Box>
              </Grid>

              {/* User Information */}
              <Grid item xs={12} md={8}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <EditableTextField
                      fullWidth
                      name={"mobile"}
                      label="Mobile Number"
                      value="+91 9876-054598"
                      variant="outlined"
                      disabled
                      isEdit={isEdit}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <EditableTextField
                      fullWidth
                      label="Password"
                      value="********"
                      variant="outlined"
                      disabled
                      type="password"
                      isEdit={isEdit}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <EditableTextField
                      fullWidth
                      label="Address"
                      value="P Block, Anna Nagar, Chennai, Tamil"
                      variant="outlined"
                      isEdit={isEdit}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <EditableTextField
                      fullWidth
                      label="Email"
                      value="Atifkhan@gmail.com"
                      variant="outlined"
                      isEdit={isEdit}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <EditableTextField
                      fullWidth
                      label="Department"
                      value="CRM"
                      variant="outlined"
                      isEdit={isEdit}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* Other Settings */}
          <Grid item xs={12}>
            <Box sx={{ my: 2 }}>
              <Divider
                sx={{
                  height: "2px",
                  backgroundColor: "gray",
                }}
                flexItem
              />
            </Box>
            <Typography variant="h6" fontWeight="500">
              Other Settings
            </Typography>
            <Box display="flex" alignItems="center" mt={2}>
              <Typography variant="body1" mr={2}>
                Notification
              </Typography>
              <Switch defaultChecked />
            </Box>
          </Grid>
        </Grid>
      </StyledPaper>
    </Box>
  );
};

export default SettingsPage;
